import { UploadTheme } from '../../base/tokens';

export const upload: UploadTheme = {
  wrapper: 'max-w-4xl mx-auto space-y-12',
  dropzone: {
    wrapper: `relative border-2 border-dashed rounded-lg p-8
      transition-all duration-300 cursor-pointer
      border-cyan-500/20 hover:border-cyan-400/30 hover:bg-cyan-500/5`,
    active: 'border-cyan-400/30 bg-cyan-500/5',
    input: 'absolute inset-0 w-full h-full opacity-0 cursor-pointer',
    content: {
      wrapper: 'flex flex-col items-center justify-center gap-4',
      icon: 'w-16 h-16 text-cyan-400/70',
      text: {
        primary: 'text-gray-300/80 text-sm',
        secondary: 'text-gray-400/60 text-xs mt-1'
      }
    },
    background: 'absolute inset-0 bg-gradient-radial from-cyan-500/5 to-transparent rounded-lg'
  },
  fileCard: {
    wrapper: 'relative bg-gray-900/50 rounded-lg border-[3px] border-cyan-500/10',
    header: {
      wrapper: 'relative flex items-center h-10 bg-gray-900/95 px-2 border-b border-cyan-500/10',
      background: 'absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,rgba(34,211,238,0.1),transparent_70%)]',
      fileNumber: {
        wrapper: 'relative -ml-6 -mt-2 z-50',
        hexagon: {
          background: 'absolute inset-0 bg-cyan-400/5 scale-[1.35] transition-colors duration-300 clip-path-hexagon',
          border: 'absolute inset-0 border border-cyan-400/20 scale-[1.2] animate-pulse-slow clip-path-hexagon',
          container: `relative flex h-9 w-9 items-center justify-center 
            clip-path-hexagon border border-cyan-500/20 bg-gray-900/80
            before:absolute before:inset-0 before:bg-gradient-to-br 
            before:from-cyan-400/5 before:to-transparent`,
          text: 'text-lg font-medium text-cyan-400 relative z-10 drop-shadow-[0_0_3px_rgba(34,211,238,0.5)]'
        }
      },
      fileName: {
        wrapper: 'flex-1 flex flex-col items-center justify-center min-w-0 px-4',
        name: 'truncate text-sm font-medium text-cyan-100/90',
        size: 'text-xs text-cyan-400/50'
      },
      removeButton: {
        wrapper: `relative -mr-6 -mt-2 h-8 w-8 flex items-center justify-center rounded-full
          border border-cyan-500/20 bg-gray-900/80 hover:border-red-500/30
          transition-all duration-300 z-30`,
        icon: 'w-5 h-5 text-cyan-400/70 hover:text-red-400 transition-all duration-300 hover:rotate-90'
      }
    }
  },
  error: {
    wrapper: 'mt-2 p-3 bg-red-500/10 border border-red-500/20 rounded-lg',
    list: 'space-y-1',
    message: 'text-sm text-red-400'
  },
  status: {
    wrapper: 'mt-4 space-y-2',
    progress: {
      wrapper: 'bg-gray-900/50 rounded-lg p-4 border border-cyan-500/20',
      text: 'text-sm text-cyan-400/70 mb-2',
      bar: {
        wrapper: 'h-2 bg-gray-800 rounded-full overflow-hidden',
        fill: 'h-full bg-gradient-to-r from-cyan-500 to-blue-500 transition-all duration-300'
      }
    },
    error: {
      wrapper: 'bg-red-500/10 border border-red-500/20 rounded-lg p-3',
      message: 'text-sm text-red-400'
    }
  }
}; 